import PropTypes from 'prop-types';

import { HeadingLevel } from 'lib/customPropTypes';

import { HX } from '../Headings';

const PanelTitle = ({ children, headingLevel, headingLevelStyle, ...rest }) => (
  <HX level={headingLevel} levelStyle={headingLevelStyle} {...rest}>
    {children}
  </HX>
);

PanelTitle.defaultProps = {
  headingLevel: 5,
  headingLevelStyle: 5,
};

PanelTitle.propTypes = {
  children: PropTypes.node.isRequired,
  headingLevel: HeadingLevel,
  headingLevelStyle: HeadingLevel,
};

export default PanelTitle;
